var _sodipodiNamedview, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47.12513mm",
    height: "11.127724mm",
    viewBox: "0 0 47.12513 11.127724",
    id: "svg5",
    inkscapeVersion: "1.2.2 (732a01da63, 2022-12-09)",
    sodipodiDocname: "drawing.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview7",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#505050",
    inkscapeDocumentUnits: "mm",
    showgrid: "false",
    inkscapeZoom: 0.99674932,
    inkscapeCx: 354.15123,
    inkscapeCy: 496.1127,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 991,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(-29.175698,-101.04902)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 300,
      fontStretch: "normal",
      fontSize: "14.1111px",
      fontFamily: "Lato",
      InkscapeFontSpecification: "'Lato Light'",
      textAlign: "center",
      textAnchor: "middle",
      fill: "none",
      fillOpacity: 0,
      stroke: "#91ff00",
      strokeWidth: 0.622001,
      strokeOpacity: 1
    },
    x: 52.55835,
    y: 111.75285,
    id: "text17000"
  }, /*#__PURE__*/React.createElement("tspan", {
    sodipodiRole: "line",
    id: "tspan16998",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Lato",
      InkscapeFontSpecification: "Lato",
      stroke: "#ffffff",
      strokeWidth: 0.622,
      strokeOpacity: 1
    },
    x: 52.55835,
    y: 111.75285
  }, "Bui Anh"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c4c85c92aace3335fb3995844e84c88.svg";
export { ForwardRef as ReactComponent };